import React from 'react';

class LogoutPanel extends React.Component {
  // Lifecycle

  componentDidMount() {
    if (window.confirm('Are you sure you wish to logout?')) {
      window.persistor.purge().then(() => {
        setTimeout(() => {
          window.localStorage.clear();
          window.location.href = '/';
        }, 100);
      });
    } else {
      this.props.history.goBack();
    }
  }

  render() {
    return <p>Logging Out...</p>;
  }
}

export default LogoutPanel;



// WEBPACK FOOTER //
// ./src/components/Dashboard/Panels/Logout/index.jsx